import * as Yup from 'yup';
import { PHONE_VERIFICATION_CODE_REGEX } from './phoneVerificationCodeRegex';

const phoneVerificationSchema = Yup.object().shape({
  verification_code: Yup.string()
    .trim()
    .required('Please enter your six\u2011digit verification\u00A0code.')
    .matches(
      PHONE_VERIFICATION_CODE_REGEX,
      'Please enter a valid six\u2011digit verification\u00A0code.'
    )
});

export { phoneVerificationSchema };
